import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { useRecommendedForYouArticlesQuery } from '../../../../../generated/frontend'
import { AssociatedArticlesImages } from '../../../../../shared'
import type { RecommendedModelType } from '../../../../../shared/components/RecommendedForYou'
import { getModelsData, Layout, Model } from '../../../../../shared/components/RecommendedForYou'
import { ModelRecommendations } from '../../../../../shared/components/RecommendedForYou/components/ModelRecommendations/ModelRecommendations'

type AssociatedArticlesImagesProps = React.ComponentProps<typeof AssociatedArticlesImages>

type ContentExperimentProps = {
  recommendedModel: RecommendedModelType
} & AssociatedArticlesImagesProps

const ContentExperiment = ({
  recommendedModel,
  position,
  ...associatedArticlesImagesProps
}: ContentExperimentProps) => {
  const showPersonalisedContent = useFeatureIsOn('DSP-025-most-recent-on-news-pages')

  if (showPersonalisedContent) {
    return (
      <ModelRecommendations
        model={recommendedModel}
        whichId="related links"
        layout={Layout.ImageLinks}
        position={position}
      />
    )
  }

  return <AssociatedArticlesImages position={position} {...associatedArticlesImagesProps} />
}

export const RecommendedForYouArticlesImages = (
  associatedArticlesImagesProps: AssociatedArticlesImagesProps
) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const allModels = getModelsData(data?.homePage.recommendations?.models ?? [])
  const mixedAdviceModel = allModels[Model.RECENT_CATEGORY]

  if (mixedAdviceModel) {
    return (
      <ContentExperiment recommendedModel={mixedAdviceModel} {...associatedArticlesImagesProps} />
    )
  }

  return <AssociatedArticlesImages {...associatedArticlesImagesProps} />
}
